import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import { UserLocation_Base } from '../models/UserLocation';

export type UserLocation_Location = {
  latitude: number;
  longitude: number;
}

// Get list user locations

export const remote_getListUserLocations = async (): Promise<UserLocation_Base[]> => {
  return ( await getAxiosInstance().get(`/api/user-location-ext/get-user-locations`) ).data;
}

// End Get list user locations

// Get user location
export type UserLocation_GetUserLocation_Request = {
  userId: number;
}
export type UserLocation_GetUserLocation_Response = UserLocation_Location;
export const remote_getUserLocation = async (request: UserLocation_GetUserLocation_Request): Promise<UserLocation_GetUserLocation_Response> => {
  return (await getAxiosInstance()
      .get(`/api/user-location-ext/get-user-location/${request.userId}`)).data;
}
// End get user location

// Get list user location of project
export const remote_getUserLocationOfProject = async (projectId: number): Promise<UserLocation_Base[]> => {
  return ( await getAxiosInstance().get(`/api/user-location-ext/user-locations-of-project/${projectId}`) ).data;
}
// End get list user location of project
export type UserLocation_UpdateMyLocation_Request = {
  location: UserLocation_Location;
  timestamp?: string;
}
export const remote_updateMyLocation = async (request: UserLocation_UpdateMyLocation_Request): Promise<AppSuccess<any>> => {
  return (await getAxiosInstance().put(`/api/user-location-ext/update-my-location`, request)).data;
}

export const UserLocationAPIs = {
  remote_getUserLocation,
  remote_updateMyLocation,
  remote_getUserLocationOfProject,
}